import { render, staticRenderFns } from "./hotPush.vue?vue&type=template&id=650e5fda&scoped=true"
import script from "./hotPush.vue?vue&type=script&lang=js"
export * from "./hotPush.vue?vue&type=script&lang=js"
import style0 from "./hotPush.vue?vue&type=style&index=0&id=650e5fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e5fda",
  null
  
)

export default component.exports